import { combineReducers } from 'redux';

const courseCategoryMasterInitialState = {
  loadStatus: 0,
  list: null,
};

const courseCategoryInitialState = {
  loadStatus: 0,
  data: null,
};

const courseInitialState = {
  loadStatus: 0,
  data: null,
};

function courseCategoryMasterReducer(
  state = courseCategoryMasterInitialState,
  action
) {
  switch (action.type) {
    case 'LOAD_COURSE_CATEGORY_LIST': {
      return {
        ...state,
        loadStatus: 1,
        list: null,
      };
    }

    case 'LOAD_COURSE_CATEGORY_LIST_COMPLETION': {
      const { list, error } = action;

      if (error) {
        return {
          ...state,
          loadStatus: 0,
        };
      }

      return {
        ...state,
        loadStatus: 2,
        list,
      };
    }

    default:
      return state;
  }
}

function courseCategoryReducer(state = courseCategoryInitialState, action) {
  switch (action.type) {
    case 'LOAD_COURSE_CATEGORY_DETAIL': {
      return {
        ...state,
        loadStatus: 1,
      };
    }

    case 'LOAD_COURSE_CATEGORY_DETAIL_COMPLETION': {
      const { data, error } = action;

      if (error) {
        return {
          ...state,
          loadStatus: 0,
        };
      }

      return {
        ...state,
        loadStatus: 2,
        data,
      };
    }

    default:
      return state;
  }
}

function courseReducer(state = courseInitialState, action) {
  switch (action.type) {
    case 'LOAD_COURSE': {
      return {
        ...state,
        loadStatus: 1,
      };
    }

    case 'LOAD_COURSE_COMPLETION': {
      const { error, data } = action;

      if (error) {
        return {
          ...state,
          loadStatus: 0,
        };
      }

      return {
        ...state,
        loadStatus: 2,
        data,
      };
    }

    default:
      return state;
  }
}

function coursesReducer(state = {}, action) {
  switch (action.type) {
    case 'LOAD_COURSE_COMPLETION': {
      const { data, error, courseId } = action;

      if (error) {
        return state;
      }

      if (data) {
        let obj = {};
        obj[courseId] = data;

        return {
          ...state,
          ...obj,
        };
      } else {
        return state;
      }
    }

    default:
      return state;
  }
}

export default combineReducers({
  categoryMaster: courseCategoryMasterReducer,
  categoryDetail: courseCategoryReducer,
  courses: coursesReducer,
  course: courseReducer,
});
